import { render, staticRenderFns } from "./VerifyCustomerPhone.vue?vue&type=template&id=3e65f2b6"
import script from "./VerifyCustomerPhone.vue?vue&type=script&lang=js"
export * from "./VerifyCustomerPhone.vue?vue&type=script&lang=js"
import style0 from "./VerifyCustomerPhone.vue?vue&type=style&index=0&id=3e65f2b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports